import { render, staticRenderFns } from "./insuranceCompanies.vue?vue&type=template&id=dd5bf218"
import script from "./insuranceCompanies.vue?vue&type=script&lang=js"
export * from "./insuranceCompanies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports